// === Zod schemas: general_task ===
// Ported from PHP Click2Gro: GeneralTaskModel / GeneralTask entity
// Table: general_task

import { z } from 'zod';
import { RowLabelNullableSchema } from './row-label';

export const GeneralTaskSchema = z.object({
  id:                    z.number().int().positive(),
  company_id:            z.string().uuid(),
  year:                  z.string().max(4).nullable(),
  finish_row:            RowLabelNullableSchema,
  start_row:             RowLabelNullableSchema,
  block_name:            z.string().max(300).nullable(),
  block_id:              z.number().int().nullable(),
  labour_id:             z.string().nullable(),
  staff_count:           z.number().int().nullable(),
  crop_variety:          z.string().max(150).nullable(),
  week:                  z.number().int().nullable(),
  crop:                  z.string().max(120).nullable(),
  created_at:            z.string().datetime({ offset: true }).nullable(),
  updated_at:            z.string().datetime({ offset: true }).nullable(),
  created_by:            z.string().max(150).nullable(),
  deleted_at:            z.string().datetime({ offset: true }).nullable(),
  block_type:            z.string().max(50).nullable(),
  reference:             z.string().max(50).nullable(),
  task_type:             z.string().max(200).nullable(),
  task:                  z.string().max(200).nullable(),
  start_time:            z.string().datetime({ offset: true }).nullable(),
  finish_time:           z.string().datetime({ offset: true }).nullable(),
  is_manual_entry:       z.number().int().min(0).max(1).nullable(),
  cost:                  z.number().nullable(),
  saved_timer_time:      z.number().int().nullable(),
  task_status:           z.string().max(100).nullable(),
  add_plants_to_reports: z.number().int().min(0).max(1).nullable(),
});

export const GeneralTaskInsertSchema = GeneralTaskSchema.omit({
  id: true,
  created_at: true,
  updated_at: true,
  deleted_at: true,
}).partial({
  year: true,
  finish_row: true,
  start_row: true,
  block_name: true,
  block_id: true,
  labour_id: true,
  staff_count: true,
  crop_variety: true,
  week: true,
  crop: true,
  created_by: true,
  block_type: true,
  reference: true,
  task_type: true,
  task: true,
  start_time: true,
  finish_time: true,
  is_manual_entry: true,
  cost: true,
  saved_timer_time: true,
  task_status: true,
  add_plants_to_reports: true,
});

export const GeneralTaskUpdateSchema = GeneralTaskInsertSchema.partial();

export type GeneralTask       = z.infer<typeof GeneralTaskSchema>;
export type GeneralTaskInsert = z.infer<typeof GeneralTaskInsertSchema>;
export type GeneralTaskUpdate = z.infer<typeof GeneralTaskUpdateSchema>;
